import { ResponseHeader } from "./ResponseHeader"

export const ResponseContentType = (
  r: Request | Response | XMLHttpRequest,
  cttp: string = "application/octet-stream"
): string => ResponseHeader(r, "content-type", cttp).split(";")[0].toLowerCase()
